
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.015 22.333V19S21 19 21 15.667c0-3.334-1.652-5-4.985-5S11 12.333 11 15.667m5 11.666h.015M31 19c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 10.716 7.716 4 16 4c8.284 0 15 6.716 15 15z","stroke":"#A6ADB5","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    